import { render, staticRenderFns } from "./sgtl.vue?vue&type=template&id=2647ad46&scoped=true"
import script from "./sgtl.vue?vue&type=script&lang=js"
export * from "./sgtl.vue?vue&type=script&lang=js"
import style0 from "./sgtl.vue?vue&type=style&index=0&id=2647ad46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2647ad46",
  null
  
)

export default component.exports